import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-img-card',
  templateUrl: './img-card.component.html',
  styleUrls: ['./img-card.component.scss'],
})
export class ImgCardComponent implements OnInit {
  @Input() title: string;
  @Input() img: string;
  @Input() color = '';
  @Input() buttonText: string;
  @Input() isDisabled = false;
  @Input() completed = false;
  @Input() isDemo = false;
  @Input() level = 0;
  @Input()
  public totalAttempts: number;
  @Input()
  public limitDemoAttempts: number;

  @Output() openSimulationDetail = new EventEmitter<any>();

  constructor(public translate: TranslateService) {
    this.limitDemoAttempts = 1;
    this.totalAttempts = 1;
  }

  ngOnInit() {
    this.buttonText = this.translate.instant(this.buttonText);   
  }

}
